import { BaseCardWrapper, twClassMerge  } from '@healthhub/react-ui';
import { Divider, Typography } from 'antd';
import type { ReactNode } from 'react';

import { OutlinedRightIcon } from '@shared/assets-icon';


const { Text } = Typography;

interface ArticleSectionProps {
  articles: { title: string; url: string }[];
  className?: string;
  icon: ReactNode;
  title?: string;
}

const ArticleSection = ({ articles, className, icon, title }: ArticleSectionProps) => {
  if (articles.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      {!!title && (
        <div className="flex items-center gap-2">
          {icon}
          <Text className="text-sm font-semibold text-primary-blue-grey">{title}</Text>
        </div>
      )}
      <div className={twClassMerge('grid grid-cols-1 gap-y-2 gap-x-6', className)}>
        {articles.map(({ title, url }) => (
          <BaseCardWrapper
            className="flex h-16 items-center gap-4 rounded-lg border border-[#4B798733] px-4 py-2"
            key={title}
          >
            <Text className="line-clamp-2 flex-1 text-sm">{title}</Text>
            <Divider className="m-0 h-full border-dashed border-functional-stone" type="vertical" />
            <a
              aria-label={`Read more about ${title}`}
              className="flex items-center text-secondary-green-500"
              href={url}
            >
              Read more <OutlinedRightIcon />
            </a>
          </BaseCardWrapper>
        ))}
      </div>
    </div>
  );
};

export default ArticleSection;
